/* De Mani Jewelry — Homepage Sale banner helper
   Reliably tags the SALE promo banner section so CSS can target it even if
   Shopify regenerates section/block IDs after editor changes.

   Included ONLY on the homepage (request.page_type == 'index').
*/

(function () {
  function normalize(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function isSaleCandidate(sectionEl) {
    var wrapper = sectionEl.querySelector('.section-content-wrapper');
    if (!wrapper) return false;

    // Look for a direct-child CTA link inside the section wrapper.
    var hasShopNowCta = false;
    var childTextBlocks = 0;
    for (var i = 0; i < wrapper.children.length; i++) {
      var child = wrapper.children[i];
      if (!child) continue;

      // Text blocks are rendered with the `.text-block` class.
      if (child.classList && child.classList.contains('text-block')) childTextBlocks++;

      // The promo CTA is usually a direct child <a>.
      if (child.tagName === 'A') {
        var ctaText = normalize(child.textContent);
        if (ctaText.indexOf('shop now') !== -1) {
          hasShopNowCta = true;
        }
      }
    }

    if (!hasShopNowCta || childTextBlocks < 2) return false;

    // Secondary signal: promo language (kept intentionally broad to survive copy changes).
    var text = normalize(sectionEl.textContent);
    var looksLikePromo =
      text.indexOf('sale') !== -1 ||
      text.indexOf('boxing day') !== -1 ||
      text.indexOf('site wide') !== -1 ||
      text.indexOf('off') !== -1 ||
      /\b\d+%\b/.test(text);

    return looksLikePromo;
  }

  function tagSaleBanner() {
    var sections = document.querySelectorAll('main [id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      var sectionEl = sections[i];
      if (!isSaleCandidate(sectionEl)) continue;

      sectionEl.classList.add('demani-sale-banner');

      var wrapper = sectionEl.querySelector('.section-content-wrapper');
      if (wrapper) wrapper.classList.add('demani-sale-banner__wrapper');

      // Tag the primary CTA (direct child button-like link).
      if (wrapper) {
        for (var j = 0; j < wrapper.children.length; j++) {
          var el = wrapper.children[j];
          if (el && el.tagName === 'A') {
            var elText = normalize(el.textContent);
            if (elText.indexOf('shop now') !== -1) {
              el.classList.add('demani-sale-banner__cta');
              break;
            }
          }
        }
      }

      // Only one on the homepage.
      break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagSaleBanner);
  } else {
    tagSaleBanner();
  }
})();
